"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipBgColor = exports.PlacementDirection = exports.TriggerDirection = exports.PopperDirection = exports.TooltipDirection = void 0;
require("react");
var TooltipDirection;
(function (TooltipDirection) {
    TooltipDirection["UP"] = "up";
    TooltipDirection["RIGHT"] = "right";
    TooltipDirection["DOWN"] = "down";
    TooltipDirection["LEFT"] = "left";
})(TooltipDirection = exports.TooltipDirection || (exports.TooltipDirection = {}));
var PopperDirection;
(function (PopperDirection) {
    PopperDirection["TOP"] = "top";
    PopperDirection["RIGHT"] = "right";
    PopperDirection["BOTTOM"] = "bottom";
    PopperDirection["LEFT"] = "left";
})(PopperDirection = exports.PopperDirection || (exports.PopperDirection = {}));
var TriggerDirection;
(function (TriggerDirection) {
    TriggerDirection["CLICK"] = "click";
    TriggerDirection["HOVER"] = "hover";
    TriggerDirection["STATIC"] = "static";
})(TriggerDirection = exports.TriggerDirection || (exports.TriggerDirection = {}));
var PlacementDirection;
(function (PlacementDirection) {
    PlacementDirection["BODY"] = "body";
    PlacementDirection["LOCAL"] = "local";
})(PlacementDirection = exports.PlacementDirection || (exports.PlacementDirection = {}));
var TooltipBgColor;
(function (TooltipBgColor) {
    TooltipBgColor["DEFAULT"] = "default";
    TooltipBgColor["GRAY"] = "gray";
    TooltipBgColor["BLUE"] = "blue";
})(TooltipBgColor = exports.TooltipBgColor || (exports.TooltipBgColor = {}));
